import { render, staticRenderFns } from "./CrmRelative.vue?vue&type=template&id=2fe8352e&scoped=true"
import script from "./CrmRelative.vue?vue&type=script&lang=js"
export * from "./CrmRelative.vue?vue&type=script&lang=js"
import style0 from "./CrmRelative.vue?vue&type=style&index=0&id=2fe8352e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe8352e",
  null
  
)

export default component.exports